<template>
  <main role="main" class="col content-spacing">
    <div
      class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom border-bottom"
    >
      <h1 class="h2" v-if="viewData.user">
        Instalações de {{ viewData.user.name }}
      </h1>
      <div class="btn-toolbar mb-2 mb-md-0">
        <div class="btn-toolbar mb-2 mb-md-0">
          <div class="btn-group mr-2">
            <BaseButtonComponent
              @click="$bvModal.show('bv-modal-example')"
              variant="secondary-action"
              >Nova Instalação</BaseButtonComponent
            >
          </div>

          <b-modal id="bv-modal-example" size="lg">
            <template v-slot:modal-title>Nova Instalação</template>

            <b-form>
              <error-container v-bind:errors="viewData.errors || []" />

              <b-form-row>
                <b-col>
                  <b-form-group
                    id="input-group-1"
                    label="Tensão"
                    label-for="input-1"
                  >
                    <b-form-select
                      v-model="state.tension"
                      :options="viewData.tensions"
                      :state="isOk('tension')"
                      class="mb-3"
                    >
                      <option disabled value>Selecione uma tensão</option>
                    </b-form-select>
                    <b-form-invalid-feedback>{{
                      getError('tension')
                    }}</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    id="input-group-1"
                    label="Modalidade tarifária"
                    label-for="input-1"
                  >
                    <b-form-select
                      v-model="state.tariffModality"
                      :options="viewData.modalities"
                      :state="isOk('tariffModality')"
                      class="mb-3"
                    >
                      <option disabled value>
                        Selecione uma modalidade tarifária
                      </option>
                    </b-form-select>
                    <b-form-invalid-feedback>{{
                      getError('tariffModality')
                    }}</b-form-invalid-feedback>
                  </b-form-group></b-col
                >
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-group
                    id="input-group-1"
                    label="Classe"
                    label-for="input-1"
                  >
                    <b-form-select
                      v-model="state.class"
                      :options="viewData.classes"
                      :state="isOk('class')"
                      class="mb-3"
                    >
                      <option disabled value>Selecione uma classe</option>
                    </b-form-select>
                    <b-form-invalid-feedback>{{
                      getError('class')
                    }}</b-form-invalid-feedback>
                  </b-form-group></b-col
                >
                <b-col
                  ><b-form-group
                    id="input-group-1"
                    label="Tipo de ligação"
                    label-for="input-1"
                  >
                    <b-form-select
                      v-model="state.connectionType"
                      :options="viewData.connectionTypes"
                      :state="isOk('connectionType')"
                      class="mb-3"
                    >
                      <option disabled value>
                        Selecione um tipo de ligação
                      </option>
                    </b-form-select>
                    <b-form-invalid-feedback>{{
                      getError('connectionType')
                    }}</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-form-row>

              <b-form-group
                id="input-group-1"
                label="Número da Instalação"
                label-for="input-1"
              >
                <b-form-input
                  v-model="state.installationNumber"
                  placeholder="Informe o Número da Instalação"
                  :state="isOk('installationNumber')"
                  @keypress="isNumber($event)"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('installationNumber')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Distribuidora"
                label-for="input-1"
              >
                <v-select
                  @search="search"
                  :options="viewData.powerPlants"
                  v-model="state.powerPlantId"
                  label="label"
                  placeholder="Pesquise por uma distribuidora..."
                >
                  <div slot="no-options">Nenhum resultado encontrado.</div>
                </v-select>

                <b-form-invalid-feedback>{{
                  getError('socialNumber')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group id="input-group-1" label="CEP" label-for="input-1">
                <b-form-input
                  v-model="state.zipCode"
                  placeholder="Informe o CEP da instalação"
                  :state="isOk('zipCode')"
                  v-mask="['#####-###']"
                  @blur="fillCompleteAddress($event)"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('zipCode')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Endereço"
                label-for="input-1"
              >
                <b-form-input
                  v-model="state.address"
                  placeholder="Informe o Endereço da instalação"
                  :state="isOk('address')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('address')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-row>
                <b-col>
                  <b-form-group
                    id="input-group-1"
                    label="Numero"
                    label-for="input-1"
                  >
                    <b-form-input
                      v-model="state.number"
                      placeholder="Informe o Número referente ao endereço da instalação"
                      :state="isOk('number')"
                      @keypress="isNumber($event)"
                    ></b-form-input>
                    <b-form-invalid-feedback>{{
                      getError('number')
                    }}</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    id="input-group-1"
                    label="Bairro"
                    label-for="input-1"
                  >
                    <b-form-input
                      v-model="state.district"
                      placeholder="Informe o Bairro da instalação"
                      :state="isOk('district')"
                    ></b-form-input>
                    <b-form-invalid-feedback>{{
                      getError('district')
                    }}</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-form-row>

              <b-form-row>
                <b-col>
                  <b-form-group
                    id="input-group-1"
                    label="Cidade"
                    label-for="input-1"
                  >
                    <b-form-input
                      v-model="state.city"
                      placeholder="Informe a Cidade da instalação"
                      :state="isOk('city')"
                    ></b-form-input>
                    <b-form-invalid-feedback>{{
                      getError('city')
                    }}</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    id="input-group-1"
                    label="Estado"
                    label-for="input-1"
                  >
                    <b-form-select
                      v-model="state.state"
                      :options="viewData.states"
                      placeholder="Selecione um Estado"
                      :state="isOk('state')"
                      class="mb-3"
                    >
                      <option disabled value>Selecione um estado</option>
                    </b-form-select>
                    <b-form-invalid-feedback>{{
                      getError('state')
                    }}</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-form-row>
            </b-form>

            <template
              v-slot:modal-footer
              style="display: block; justify-content: flex-start"
            >
              <BaseButtonComponent
                style="float: left"
                @click="$bvModal.hide('bv-modal-example')"
                variant="danger"
                >Fechar</BaseButtonComponent
              >

              <BaseButtonComponent
                style="float: right"
                @click="save"
                variant="primary-action"
              >
                <b-icon
                  v-if="viewData.saving"
                  icon="three-dots"
                  animation="cylon"
                ></b-icon>
                <span v-else>Criar Instalação</span>
              </BaseButtonComponent>
            </template>
          </b-modal>
        </div>
      </div>
    </div>

    <b-row v-if="this.viewData.user">
      <b-col>
        <b-breadcrumb
          :items="[
            {
              text:
                'Lista de ' + this.getProfileName(this.viewData.user.profile),
              href: '/#/' + this.viewData.user.profile + 's',
            },
            {
              text: 'Edição de ' + viewData.user.name,
              href: `/#/user/edit/${this.viewData.user.id}/${this.viewData.user.profile}`,
            },
            {
              text: 'Instalações',
              href: '#',
              active: true,
            },
          ]"
        ></b-breadcrumb>
      </b-col>
    </b-row>

    <loading-list v-if="viewData.loading"></loading-list>

    <div
      v-else-if="!viewData.loading && state.list && state.list.length > 0"
      class="table-responsive"
    >
      <table class="table b-table  table-hover table-bordered">
        <thead>
          <tr>
            <td>Número</td>
            <td>Distribuidora</td>
            <td>Endereço</td>
            <td>CEP</td>
            <td>Cidade</td>
            <td>Estado</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in state.list" :key="item.id">
            <td>{{ item.installationNumber }}</td>
            <td>{{ item.distributor }}</td>
            <td>{{ item.address }}, {{ item.number }}</td>
            <td>{{ formatZipCode(item.zipCode) }}</td>
            <td>{{ item.city }}</td>
            <td>{{ item.state }}</td>
            <td style="text-align: right">
              <BaseButtonComponent
                size="sm"
                :to="
                  `/user/${viewData.userId}/installation/${item.id}/billings/${viewData.accountId}`
                "
                v-b-tooltip.hover
                title="Faturas"
                variant="secondary-action"
              >
                <b-icon-credit-card></b-icon-credit-card>
              </BaseButtonComponent>

              <BaseButtonComponent
                size="sm"
                :to="
                  `/user/${viewData.userId}/installation/${item.id}/discounts/${viewData.accountId}`
                "
                v-b-tooltip.hover
                title="Descontos"
                variant="secondary-action"
              >
                <b-icon-cash-stack></b-icon-cash-stack>
              </BaseButtonComponent>

              <BaseButtonComponent
                size="sm"
                :to="`/installation/edit/${item.id}`"
                v-b-tooltip.hover
                title="Editar"
                variant="primary-action"
              >
                <b-icon icon="pencil-square" aria-hidden="true"></b-icon>
              </BaseButtonComponent>

              <BaseButtonComponent
                @click="() => remove(item)"
                size="sm"
                v-b-tooltip.hover
                title="Excluir"
                variant="danger"
              >
                <b-icon icon="trash" aria-hidden="true"></b-icon>
              </BaseButtonComponent>
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination-nav
        :link-gen="linkGen"
        :number-of-pages="state.pageCount"
        use-router
      ></b-pagination-nav>
    </div>
    <empty-list v-else-if="!viewData.loading"></empty-list>
  </main>
</template>

<script>
import helpers from '../../vue/helpers';
import { Api } from '../../vue/api';
import StatesJson from '../../vue/estados.json';
import { BaseButtonComponent } from '../../ui/buttons';

const API = new Api();

export default {
  name: 'installations-index',
  data: function() {
    return {
      state: {
        list: [],
        address: '',
        city: '',
        couponDescription: '',
        couponValue: null,
        couponPercentage: null,
        installationNumber: null,
        distributor: '',
        district: '',
        number: null,
        state: '',
        zipCode: '',
        powerPlantId: 0,
        tension: '',
        tariffModality: '',
        class: '',
        connectionType: '',
      },
      viewData: {
        loading: true,
        saving: false,
        errors: [],
        states: [],
        userId: 0,
        accountId: 0,
        user: null,
        powerPlants: [],
        tensions: [],
        modalities: [],
        classes: [],
        connectionTypes: [],
      },
    };
  },
  computed: {},
  beforeMount: async function() {
    this.viewData.states = StatesJson.estados;
    this.viewData.tensions = [
      { value: '1_BAIXA', text: '1_BAIXA' },
      { value: '2_MEDIA', text: '2_MEDIA' },
      { value: '3_ALTA', text: '3_ALTA' },
    ];
    this.viewData.modalities = [
      { value: 'B1', text: 'B1' },
      { value: 'B2', text: 'B2' },
      { value: 'B3', text: 'B3' },
      { value: 'A4_Verde', text: 'A4_Verde' },
    ];

    this.viewData.classes = [
      {
        value: '1_RESIDENCIAL',
        text: '1_RESIDENCIAL',
      },
      {
        value: '2_COMERCIAL',
        text: '2_COMERCIAL',
      },
      {
        value: '3_INDUSTRIAL',
        text: '3_INDUSTRIAL',
      },
      {
        value: '4_RURAL',
        text: '4_RURAL',
      },
      {
        value: '5_PODER_PUBLICO',
        text: '5_PODER_PUBLICO',
      },
      {
        value: '6_SERVICO_PUBLICO',
        text: '6_SERVICO_PUBLICO',
      },
    ];

    this.viewData.connectionTypes = [
      { value: '1_MONOFASICO', text: '1_MONOFASICO' },
      { value: '2_BIFASICO', text: '2_BIFASICO' },
      { value: '3_TRIFASICO', text: '3_TRIFASICO' },
    ];

    try {
      const result = await API.post('/execute', {
        path: '/user/' + this.$route.params.id,
        method: 'get',
      });

      this.viewData.user = result.model;
      this.viewData.userId = result.model.id;

      const resultAccount = await API.post('/execute', {
        path: '/account/' + this.$route.params.accountId,
        method: 'get',
      });

      this.viewData.user.profile = resultAccount.model.profile;
    } catch (ex) {
      this.$toast.error(helpers.getFirstError(ex));
      return;
    }

    await this.getAll();
  },
  methods: {
    getProfileName(profile) {
      if (profile && profile === 'consumer') {
        return 'Consumidores';
      } else if (profile && profile === 'trader') {
        return 'Comercializadores';
      } else if (profile && profile === 'partner') {
        return 'Parceiros';
      } else if (profile && profile === 'investor') {
        return 'Investidores';
      } else {
        return 'Usuários';
      }
    },
    async search(search) {
      if (!search) {
        this.viewData.powerPlants = [];
        return;
      }

      try {
        const result = await API.post('/execute', {
          path: '/power-plants-search?search=' + search,
          method: 'get',
        });

        this.viewData.powerPlants = result.model || [];
      } catch (ex) {
        this.viewData.powerPlants = [];
      }
    },
    async save() {
      this.viewData.saving = true;

      try {
        const result = await API.post('/execute', {
          path: `/user/${this.viewData.accountId}/installation`,
          method: 'post',
          data: {
            address: this.state.address,
            city: this.state.city,
            couponDescription: this.state.couponDescription,
            couponValue: this.state.couponValue ? this.state.couponValue : 0,
            couponPercentage: this.state.couponPercentage
              ? this.state.couponPercentage
              : 0,
            installationNumber: this.state.installationNumber,
            district: this.state.district,
            distributor: this.state.distributor,
            number: this.state.number ? this.state.number : 0,
            state: this.state.state,
            zipCode: this.state.zipCode.replace('-', ''),
            powerPlantId: this.state.powerPlantId.id,
            tension: this.state.tension,
            tariffModality: this.state.tariffModality,
            class: this.state.class,
            connectionType: this.state.connectionType,
          },
        });

        this.$bvModal.hide('bv-modal-example');
        await this.getAll();
      } catch (ex) {
        this.viewData.errors = helpers.getErrors(ex);
      }

      this.viewData.saving = false;
    },
    async getAll() {
      try {
        this.viewData.accountId = this.$route.params.accountId;
        this.viewData.loading = true;

        const result = await API.post('/execute', {
          path: `/user/${this.viewData.accountId}/installations`,
          method: 'get',
        });

        this.state.list = result.model.list;
        this.viewData.loading = false;
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    },
    async remove(item) {
      const ok = await this.$bvModal.msgBoxConfirm(
        'Deseja mesmo excluir essa instalação ?',
        {
          title: 'Confirmar Exclusão',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Sim',
          cancelTitle: 'Não',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        },
      );

      if (!ok) {
        return;
      }

      try {
        this.viewData.loading = true;

        const result = await API.post('/execute', {
          path: '/installation/' + item.id,
          method: 'delete',
        });

        await this.getAll();
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    },
    linkGen(pageNum) {
      return pageNum === 1 ? '?' : `?page=${pageNum}`;
    },
    async fillCompleteAddress() {
      if (this.isZipCode(this.state.zipCode)) {
        let response = await this.$http.get(
          `https://viacep.com.br/ws/${this.state.zipCode}/json`,
        );

        if (response.statusCode === 200 && !response.error) {
          this.state.address = response.body.logradouro;
          this.state.district = response.body.bairro;
          this.state.city = response.body.localidade;
          this.state.state = response.body.uf;
        }
      }
    },
    isZipCode(zipCode) {
      let re = /^([\d]{2})\.*([\d]{3})-*([\d]{3})/;

      if (re.test(zipCode)) {
        return true;
      } else {
        return false;
      }
    },
    formatZipCode(zipCode) {
      let re = /^([\d]{2})\.*([\d]{3})-*([\d]{3})/;

      if (this.isZipCode(zipCode)) {
        return zipCode.replace(re, '$1.$2-$3');
      } else {
        return zipCode;
      }
    },
    getError(property) {
      return helpers.getError(this.viewData.errors, property);
    },
    isOk(property) {
      let hasError = helpers.hasError(this.viewData.errors, property);
      if (hasError) {
        return false;
      }
    },
    isNumber($event) {
      return helpers.isNumber($event);
    },
  },
  components: {
    BaseButtonComponent,
  },
};
</script>
